<div class="achtergrond" (clickOutside)="sluit()" [delayClickOutsideInit]="true" [style.top]="top + 'px'" [style.maxWidth]="width + 'px'">
  <div *ngFor="let row of data" class="row" (click)="toggle(row)">
    <div class="checkbox"><i [class]="row.geselecteerd ? 'checked' : 'unchecked'"></i></div>
    <div class="afkorting">{{row.afkorting}}</div>
    <div class="key">{{row.naam}}</div>
  </div>
</div>
